import styled from 'styled-components';

export const ApplicationSectionStyled = styled(`section`)`
	display: block;
	@media (max-width: 575px) {
		display: none;
	}
`;

export const ApplicationContentStyled = styled(`div`)`
	display: flex;
	margin-top: 40px;
	width: 1200px;

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		gap: 64px;
		flex-direction: column;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		gap: 64px;
		flex-direction: row;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		gap: 64px;
		flex-direction: row;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		gap: 64px;
		flex-direction: row;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		gap: 64px;
		flex-direction: row;
	}
`;

export const ApplicationSideStyled = styled(`div`)`
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 508px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 162px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 215px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 282px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		width: 282px;
	}
`;
export const ApplicationMainStyled = styled(`div`)`
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 508px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 462px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 637px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 854px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		width: 854px;
	}
`;
